import { render } from "./ClientesTable.vue?vue&type=template&id=6cc66966"
import script from "./ClientesTable.vue?vue&type=script&lang=js"
export * from "./ClientesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__